import { Link } from 'react-router';
import '../../styles/Footer.css';
import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiCall } from '../../hooks/useApiCall';
import {
  RiFacebookCircleFill,
  RiInstagramFill,
  RiPhoneFill,
  RiWhatsappFill,
  RiMailFill,
  RiMapPinFill,
  RiTruckFill,
  RiRefreshFill,
  RiShieldCheckFill,
  RiCustomerService2Fill,
  RiPriceTag3Fill
} from 'react-icons/ri';

function Footer() {
  const navigate = useNavigate();
  const apiCall = useApiCall();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [footerPages, setFooterPages] = useState([]);

  const fetchFooterCategories = useCallback(async () => {
    try {
      const response = await apiCall('categories/footer', 'GET');
      if (response && response.success && response.data) {
        setCategories(response.data.categories || []);
      }
    } catch (error) {
      console.error('Error fetching footer categories:', error);
    } finally {
      setLoading(false);
    }
  }, [apiCall]);

  const fetchFooterPages = useCallback(async () => {
    try {
      const response = await apiCall('pages/get-by-placement', 'POST', { placement: 'footer' });
      if (response && response.success && response.data) {
        setFooterPages(response.data.pages || []);
      }
    } catch (error) {
      console.error('Error fetching footer pages:', error);
    }
  }, [apiCall]);

  useEffect(() => {
    fetchFooterCategories();
    fetchFooterPages();
  }, []);

  const handleCategoryClick = (category) => {
    navigate(`/products/category/${category.id}/${category.slug}`);
  };

  // Split categories into two groups
  const firstSixCategories = categories.slice(0, 6);
  const lastFourCategories = categories.slice(6, 10);

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          
          {/* Shop Categories - First 6 */}
          <div className="footer-section">
            <h4 className="footer-title">Shop by Categories</h4>
            <ul className="footer-links">
              {loading ? (
                <li>Loading...</li>
              ) : firstSixCategories.length > 0 ? (
                firstSixCategories.map((category) => (
                  <li key={category.id}>
                    <button onClick={() => handleCategoryClick(category)}>
                      {category.name}
                    </button>
                  </li>
                ))
              ) : (
                <li>No categories available</li>
              )}
            </ul>
          </div>

          {/* Shop Categories - Overflow (Last 4) */}
          {!loading && lastFourCategories.length > 0 && (
            <div className="footer-section">
              <h4 className="footer-title" style={{ visibility: 'hidden' }}>.</h4>
              <ul className="footer-links">
                {lastFourCategories.map((category) => (
                  <li key={category.id}>
                    <button onClick={() => handleCategoryClick(category)}>
                      {category.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Help & Support */}
          {/* <div className="footer-section">
            <h4 className="footer-title">Help & Support</h4>
            <ul className="footer-links">
              <li><Link to ="/contact">Customer Service</Link></li>
              <li><Link to ="/faq">FAQ</Link></li>
            </ul>
          </div> */}

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <RiPhoneFill className="contact-icon" />
                <span>+597 546-450</span>
              </div>
              <div className="contact-item">
                <RiWhatsappFill className="contact-icon" />
                <span>+597 761-0333</span>
              </div>
              <div className="contact-item">
                <RiMailFill className="contact-icon" />
                <span>info@buildingdepotsr.com</span>
              </div>
              <div className="contact-item">
                <RiMapPinFill className="contact-icon" />
                <span>Paramaribo, Suriname</span>
              </div>
            </div>
            
            <div className="footer-social">
              <h5>Follow Us</h5>
              <div className="social-links">
                <a href="https://www.facebook.com/buildingdepotsr/" target='_blank' rel="noreferrer" aria-label="Facebook"><RiFacebookCircleFill /></a>
                <a href="https://www.instagram.com/buildingdepotsuriname/?hl=en" target='_blank' rel="noreferrer" aria-label="Instagram"><RiInstagramFill /></a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Features Bar */}
      <div className="footer-features">
        <div className="footer-container">
          <div className="features-grid">
          
            <div className="feature-item">
              <RiRefreshFill className="footer-feature-icon" />
              <div className="feature-text">
                <strong>Return items</strong>
                <span>in accordance with our terms and conditions which are available for inspection at the information desk.</span>
              </div>
            </div>
            <div className="feature-item">
              <RiShieldCheckFill className="footer-feature-icon" />
              <div className="feature-text">
                <strong>Quality Guarantee</strong>
                <span>Supplier's warranty on all items.</span>
              </div>
            </div>
            <div className="feature-item">
              <RiCustomerService2Fill className="footer-feature-icon" />
              <div className="feature-text">
                <strong>Expert Support</strong>
                <span>Design consultation.</span>
              </div>
            </div>
            <div className="feature-item">
              <RiPriceTag3Fill className="footer-feature-icon" />
              <div className="feature-text">
                <strong>Disclaimer</strong>
                <span>Prices are subject to change.</span>
                <span>Photos may differ from the actual products.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <div className="footer-logo">
              <span>Building Depot: Lights & Living</span>
            </div>
            <div className="footer-legal">
              <span>© {new Date().getFullYear() } Building Depot: Lights & Living. All rights reserved.</span>
              <div className="legal-links">
                {footerPages.map((page) => (
                  <button key={page.id} onClick={() => navigate(`/page/${page.slug}`)}>
                    {page.title}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
